import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext, useModel, useStateManager } from "@bcm-dev/bcms-vite";
import { PageContainer, PageContentView } from 'components/shared';
import Classes, { Account, OneTimeWireTransfer, WireHistory } from "model";
import React from 'react';
import PendingWireWidget from './components/PendingWireWidget';
import ProcessedWireTemplatesWidget from './components/ProcessedWireTemplatesWidget';
import ScheduledWiresWidget from './components/ScheduledWiresWidget';
import WireHistoryWidget from './components/WireHistoryWidget';
import WireSearch from './components/WireHistoryWidget/classes/WireSearch';

import "./styles.css";
import "./mobile.css";


/**
 * @function WiresActivityPage
 * @return {React.Component}
 * @exported true
 * @description The page for wire activity
 */

export default function WiresActivityPage(props) {
  const globalController = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, globalController);

  // Branding options needed for captures
  const branding = useModel().branding.options;
  window.BRANDING = { 
      "wires_abi22" : branding.wires_abi22
  };

  const data = { ...getDefaultData(), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,

    // Modify the data in this page from a widget.
    modifyPageDataFromWidget: (widgetID, dataProp) => val => {
      BCMSStateManagerCRUD.init(state)
      .update([ "data", widgetID, dataProp ], val)
      .submit(setState);
    }
  });

  return(
    <PageContainer className="wires-activity-page" state={ { data, ui } } controller={ controller }>
      <PageContent/>
    </PageContainer>
  );
}

export const getDefaultData = () => ({
  pendingWireWidgetData: {
    // no data used for now.
    oneTimeWireTransfers: OneTimeWireTransfer.initAll().filter(item => item.status === "pending approval")
  },
  scheduledWiresWidgetData: {
    // no data used for now.
  },
  wireHistoryWidgetData: {
    accounts: Account.initAllAsset(),
    showSearchOptions: { isActive: false },
    wireHistory: WireHistory.initAll(),
    search: WireSearch.init()
    //showSearchOptions: true,
    // Example of setting search values.
    //search: WireSearch.init({dateRange: "today"})
  }
});

// no ui changes for now
export const getDefaultUI = () => ({
  pendingWireWidgetUI: {
    
  },
  scheduledWiresWidgetUI: {
    
  },
  wireHistoryWidgetUI: {

  }
});

function PageContent(props) {
  const { data, ui, modifyPageDataFromWidget } = useStateManager();
  const { branding } = useModel() ?? {};
  const { options } = branding ?? {};
  const hasNotifyPayeeColumn = options.wire_activity_processed_widget_abi22 === "true";
  const action = { modifyPageDataFromWidget: modifyPageDataFromWidget };

  return (
  <PageContentView>
    <div className="flex-container flex-vertical flex-width">
      <PendingWireWidget data={ data.pendingWireWidgetData } ui={ ui.pendingWireWidgetUI } action={ action } />
      <ScheduledWiresWidget data={ data.scheduledWiresWidgetData } ui={ ui.scheduledWiresWidgetUI } action={ action } />
      <WireHistoryWidget data={ data.wireHistoryWidgetData } ui={ ui.wireHistoryWidgetUI } action={ action } />
      { hasNotifyPayeeColumn && <ProcessedWireTemplatesWidget /> }
    </div>
  </PageContentView>
  );
}